{{if type == 0}}
    <!--消费明细-->
    {{each OnlyOneData item index}}
        <div class="detail-info clearfix" >
            <div class="fl">
                <h5 class="name">{{item.Remark}}</h5>
                <h6 class="des">{{item.ShowTime}}</h6>
            </div>
            {{if item.CurrentValue>0}}
                <div class="fr" style="color:#FF5379">
                    {{item.CurrentValue}}
                </div>
            {{else}}
                <div class="fr" style="color:#333333">
                    {{item.CurrentValue}}
                </div>
            {{/if}}
        </div>
    {{/each}}
{{else if type == 1}}
    <!--提现明细-->
    {{each OnlyOneData item index}}
        <div class="detail-info clearfix" >
            <div class="fl">
                {{if item.VerifyStatus==0}}
                    <h5 class="name" style="color: #666">{{item.VerifyStatusText}}</h5>
                    <h6 class="des">申请提现：{{item.SubmitTime}}</h6>
                {{else if item.VerifyStatus==1}}
                    <h5 class="name">{{item.VerifyStatusText}}</h5>
                    <h6 class="des">申请提现：{{item.SubmitTime}}&nbsp &nbsp &nbsp 到账时间：{{item.VerifyTime}}</h6>
                {{else if item.VerifyStatus==2}}
                    <h5 class="name" style="color:#FF5379">{{item.VerifyStatusText}}</h5>
                    <h6 class="des">申请提现：{{item.SubmitTime}}</h6>
                {{else}}
                    <h5 class="name">{{item.VerifyStatusText}}</h5>
                    <h6 class="des">申请提现：{{item.SubmitTime}}</h6>
                {{/if}}
            </div>
            
            {{if item.VerifyStatus==0}}
                <div class="fr" style="color:#666">
                    {{item.Cash}}
                </div>
            {{else if item.VerifyStatus==2}}
                <div class="fr" style="color:#FF5379">
                    {{item.Cash}}
                </div>
            {{else}}
                <div class="fr" style="color:#333333">
                    {{item.Cash}}
                </div>
            {{/if}}
        </div>
    {{/each}}
{{/if}}